// extracted by css-extract-rspack-plugin
export default {"theme-wrapper":"c9OW4X","themeWrapper":"c9OW4X","close-button":"dfBxNc","closeButton":"dfBxNc"};